import { render, staticRenderFns } from "./EditCancelReason.vue?vue&type=template&id=1b805896&scoped=true&"
import script from "./EditCancelReason.vue?vue&type=script&lang=js&"
export * from "./EditCancelReason.vue?vue&type=script&lang=js&"
import style0 from "./EditCancelReason.vue?vue&type=style&index=0&id=1b805896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b805896",
  null
  
)

export default component.exports